import { render, staticRenderFns } from "./AppBtnCollapse.vue?vue&type=template&id=9e9bef5a&scoped=true&"
import script from "./AppBtnCollapse.vue?vue&type=script&lang=ts&"
export * from "./AppBtnCollapse.vue?vue&type=script&lang=ts&"
import style0 from "./AppBtnCollapse.vue?vue&type=style&index=0&id=9e9bef5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9bef5a",
  null
  
)

export default component.exports